var _classCallCheck = require("/home/vsts/work/1/s/Rently.CustomerSite.Web/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vsts/work/1/s/Rently.CustomerSite.Web/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * @author Timur Kuzhagaliyev <tim.kuzh@gmail.com>
 * @copyright 2019
 * @license MIT
 */
var ExactTrie =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * @param {object} [options]
   * @param {boolean} [options.ignoreCase]
   */
  function ExactTrie() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ExactTrie);

    this.trie = {};
    this.ignoreCase = options.ignoreCase !== undefined ? !!options.ignoreCase : true;
  }
  /**
   * @param {string} key
   * @param {*} value
   * @param {boolean} [reverse]
   * @returns {ExactTrie}
   */


  _createClass(ExactTrie, [{
    key: "put",
    value: function put(key, value) {
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (this.ignoreCase) key = key.toLowerCase();
      var curr = this.trie;

      if (reverse) {
        for (var i = key.length - 1; i >= 0; --i) {
          var char = key.charAt(i);
          if (!curr[char]) curr[char] = {};
          curr = curr[char];
        }
      } else {
        for (var _i = 0; _i < key.length; ++_i) {
          var _char = key.charAt(_i);

          if (!curr[_char]) curr[_char] = {};
          curr = curr[_char];
        }
      }

      curr['__'] = value;
      return this;
    }
    /**
     * @param {string[]} keys
     * @param {*|*[]} values
     * @param {boolean} [reverse]
     * @returns {ExactTrie}
     */

  }, {
    key: "putAll",
    value: function putAll(keys, values) {
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var valuesIsArray = toString.call(values) === '[object Array]';

      for (var i = 0; i < keys.length; ++i) {
        this.put(keys[i], valuesIsArray ? values[i] : values, reverse);
      }

      return this;
    }
    /**
     * @param {string} key
     * @param {boolean} [reverse]
     * @returns {*}
     */

  }, {
    key: "get",
    value: function get(key) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.ignoreCase) key = key.toLowerCase();
      var curr = this.trie;

      if (reverse) {
        for (var i = key.length - 1; i >= 0; --i) {
          var char = key.charAt(i);
          var next = curr[char];
          if (!next) return;
          curr = next;
        }
      } else {
        for (var _i2 = 0; _i2 < key.length; _i2++) {
          var _char2 = key.charAt(_i2);

          var _next = curr[_char2];
          if (!_next) return;
          curr = _next;
        }
      }

      return curr['__'];
    }
    /**
     * @param {string[]} keys
     * @param {boolean} [reverse]
     * @returns {*[]}
     */

  }, {
    key: "getAll",
    value: function getAll(keys) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var values = new Array(keys.length);

      for (var i = 0; i < keys.length; ++i) {
        values[i] = this.get(keys[i], reverse);
      }

      return values;
    }
    /**
     * @param {string} key
     * @param {boolean} [reverse]
     * @returns {boolean}
     */

  }, {
    key: "has",
    value: function has(key) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.get(key, reverse) !== undefined;
    }
    /**
     * @param {string[]} keys
     * @param {boolean} [reverse]
     * @returns {boolean[]}
     */

  }, {
    key: "hasAll",
    value: function hasAll(keys) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var values = new Array(keys.length);

      for (var i = 0; i < keys.length; ++i) {
        values[i] = this.has(keys[i], reverse);
      }

      return values;
    }
    /**
     * @param {string} string
     * @param {string|null} [checkpointChar]
     * @param {boolean} [reverse]
     * @returns {*}
     */

  }, {
    key: "getWithCheckpoints",
    value: function getWithCheckpoints(string) {
      var checkpointChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (this.ignoreCase) string = string.toLowerCase();
      var candidate = undefined;
      var curr = this.trie;

      if (reverse) {
        for (var i = string.length - 1; i >= 0; --i) {
          var char = string.charAt(i);
          var next = curr[char];
          if (!next) break;

          if (checkpointChar === null || char === checkpointChar) {
            var _val = curr['__'];
            if (_val) candidate = _val;
          }

          curr = next;
        }
      } else {
        for (var _i3 = 0; _i3 < string.length; ++_i3) {
          var _char3 = string.charAt(_i3);

          var _next2 = curr[_char3];
          if (!_next2) break;

          if (_char3 === checkpointChar) {
            var _val2 = curr['__'];
            if (_val2) candidate = _val2;
          }

          curr = _next2;
        }
      }

      var val = curr['__'];
      if (val) candidate = val;
      return candidate;
    }
    /**
     * @param {string[]} keys
     * @param {string|null} [checkpointChar]
     * @param {boolean} [reverse]
     * @returns {*[]}
     */

  }, {
    key: "getAllWithCheckpoints",
    value: function getAllWithCheckpoints(keys) {
      var checkpointChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var values = new Array(keys.length);

      for (var i = 0; i < keys.length; ++i) {
        values[i] = this.getWithCheckpoints(keys[i], checkpointChar, reverse);
      }

      return values;
    }
    /**
     * @param {string} string
     * @param {string|null} [checkpointChar]
     * @param {boolean} [reverse]
     * @returns {*}
     */

  }, {
    key: "hasWithCheckpoints",
    value: function hasWithCheckpoints(string) {
      var checkpointChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.getWithCheckpoints(string, checkpointChar, reverse) !== undefined;
    }
    /**
     * @param {string[]} keys
     * @param {string|null} [checkpointChar]
     * @param {boolean} [reverse]
     * @returns {boolean[]}
     */

  }, {
    key: "hasAllWithCheckpoints",
    value: function hasAllWithCheckpoints(keys) {
      var checkpointChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var values = new Array(keys.length);

      for (var i = 0; i < keys.length; ++i) {
        values[i] = this.hasWithCheckpoints(keys[i], checkpointChar, reverse);
      }

      return values;
    }
  }]);

  return ExactTrie;
}();

module.exports = ExactTrie;